<template>
    <v-container v-if="rechargeCardEnable === 0" style="background: #effafc;">
        <div class="container-tabs">
            <h1 style="position: relative;height: 50px;top: 50%;left: 40%;">Nạp thẻ đang được bảo trì</h1>
        </div>
    </v-container>
    <v-container v-else grid-list-md class="form-user-payment-card">
        <v-row>
            <v-col>
                <v-card class="notice pa-2 white--text bg-gradient" outlined >
                    <p>
                        <span class="font-weight-bold">Lưu ý:</span><br>
                        Nạp bằng thẻ điện thoại phí nạp 35%. (Ví dụ nạp thẻ 100.000đ sẽ được nạp 65.000đ)
                    </p>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="pa-2 bg-white" outlined>

                    <v-form ref="form_user_recharge_card">
                        <span class="mb-2">Chọn nhà mạng</span>
                        <v-select
                            solo
                            :items="homeNetworks"
                            v-model="homeNetwork"
                            item-text="name"
                            item-value="value"
                            :rules="homeNetworkRules"
                            @change="setMobileDenoms()"
                        ></v-select>
                        <span class="mb-2">Chọn mệnh giá</span>
                        <v-select
                            solo
                            :items="mobileDenoms"
                            v-model="mobileDenom"
                            item-text="name"
                            item-value="value"
                            :rules="mobileDenomRules"
                        ></v-select>
                        <span class="mb-2">Số seri</span>
                        <v-text-field
                            v-model="seri"
                            solo
                            required
                            type="number"
                            :rules="seriRules"
                        ></v-text-field>
                        <span class="mb-2">Mã thẻ cào</span>
                        <v-text-field
                            v-model="pin"
                            solo
                            required
                            type="number"
                            :rules="pinRules"
                        ></v-text-field>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-card class="pa-2 red--text" outlined style="font-weight: 500;">
                    - Gửi sai mệnh giá sẽ mất 100% thẻ, vì vậy hãy nhìn lại mệnh giá 1 lần nữa trước khi bấm NẠP TIỀN để tránh mất tiền.<br>
                    - Nạp sai mệnh giá và sai quá nhiều lần và có hành vi spam sẽ bị hủy thẻ. Vi phạm nhiều = Banned<br>
                    - Bên Mình Không Chịu Trách Nhiệm Dưới Mọi Hình Thức Đối Với Các Hình Thức Giả Mạo Trên Facebook
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-btn width="100%" height="50px" color="blue" class="white--text" @click="rechargeCard()">
                    Nạp Tiền
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import {
        AUTH_GET_INFO_RECHARGE,
        AUTH_POST_RECHARGE,
        CONFIG_PAGE
    } from "~/store/actions.type";

    import {formatCurrency} from "~/common/helper.string";
    import Swal from 'sweetalert2';

    export default {
        name: "UserPaymentCard",
        data() {
            return {
                rechargeCardEnable: 1,
                homeNetwork: 1, // vietel
                homeNetworks: [],
                homeNetworkRules: [
                    v => !!v || 'Vui lòng chọn nhà mạng',
                ],

                mobileDenom: 1, // min 10k cua Viettel
                mobileDenoms: [],
                mobileDenomAll:[],
                mobileDenomRules: [
                    v => !!v || 'Vui lòng chọn mệnh giá',
                ],

                seri: '',
                seriRules: [
                    v => !!v || 'Vui lòng nhập số seri',
                ],

                pin: '',
                pinRules: [
                    v => !!v || 'Vui lòng nhập mã thẻ cào',
                ],
                dataDetail: [],

                discount: 0,
                card: '',
            }
        },
        watch: {
            method() {
                this.getDetailForm();
            },
        },
        methods: {
            async getDataFromApi () {

                await this.$store.dispatch(CONFIG_PAGE).then((data) => {
                    let rechargeCardStatus = data.filter(o => o.key == 'key_cp_recharge_card');
                    this.rechargeCardEnable = parseInt(rechargeCardStatus[0]['status']);
                });

                this.getDetailForm();
            },
            async getDetailForm(){
                let dataDetail = await this.$store.dispatch(AUTH_GET_INFO_RECHARGE);

                if (dataDetail !== false) {
                    this.dataDetail = dataDetail;
                    for (let i = 0; i < Object.values(dataDetail.mobile_denominations).length; i++) {
                        this.homeNetworks.push({
                            name: Object.values(dataDetail.mobile_denominations)[i].name,
                            value: Object.values(dataDetail.mobile_denominations)[i].id
                        });
                    }

                    for (let i = 0; i < Object.values(dataDetail.mobile_denom_all).length; i++) {
                        this.mobileDenomAll.push({
                            name: formatCurrency(Object.values(dataDetail.mobile_denom_all)[i].value)
                                + " VND",
                            value: i + 1,
                            nameValue: Object.values(dataDetail.mobile_denom_all)[i].value
                        });
                    }
                }

                this.setMobileDenoms();
            },
            async setMobileDenoms(){
                this.mobileDenoms = [];
                let denomValueArray = Object.values(this.dataDetail.mobile_denominations)[this.homeNetwork-1].denom_value;

                this.mobileDenom = denomValueArray[0].id;

                for(let i=0; i< denomValueArray.length; i++) {
                    this.mobileDenoms.push({
                        name: formatCurrency(denomValueArray[i].val) +" VND",
                        value: denomValueArray[i].id,
                        nameValue: denomValueArray[i].val,
                        discount: denomValueArray[i].discount,
                        card: denomValueArray[i].card,
                    });
                }
            },
            getParams() {
                let param = {
                    form_convert_id: 5,
                    home_network_id: this.homeNetwork,
                    seri: this.seri,
                    pin: this.pin,
                    money: this.mobileDenomAll[this.mobileDenom-1].nameValue,
                    discount: this.mobileDenoms[this.mobileDenom-1].discount,
                    card: this.mobileDenoms[this.mobileDenom-1].card,
                };
                return param;
            },
            getHmlConfirm() {
                let html = "<span>" +
                    "Nhà mạng: " + this.homeNetworks[this.homeNetwork-1].name + "<br>" +
                    "Số seri: " + this.seri + "<br>" +
                    "Mã thẻ cào: " + this.pin + "<br>" +
                    "Mệnh giá: " + this.mobileDenomAll[this.mobileDenom-1].name + "<br>" +
                    "tương ứng với số coin: <b>" + formatCurrency(parseInt(this.mobileDenomAll[this.mobileDenom-1].nameValue) * 65/100)  + "</b> (65%) "
                    "</span>";
                return html;
            },
            validateForm() {
                let validate = this.$refs.form_user_recharge_card.validate();
                return validate;
            },
            rechargeCard(){
                if (this.validateForm()) {
                    Swal.fire({
                        title: 'Bạn có chắc chắn muốn nạp tiền với thông tin:',
                        html: this.getHmlConfirm(),
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Vâng, Chính xác!',
                        cancelButtonText: 'Không'
                    }).then((result) => {
                        if (result.value) {
                            this.$store.dispatch(AUTH_POST_RECHARGE, this.getParams()).then();
                        }
                    })
                }
            }
        },
        mounted() {
            this.getDataFromApi();
        }
    }
</script>

<style lang="scss">
    @import "../../scss/main";
    .form-user-payment-card {
        background-color: $bgMainColor;
        max-width: 100% !important;
    }
    .swal2-popup{
        font-family: Arial !important;
    }
    .swal2-popup .swal2-header .swal2-title{
        font-size: 21px;
    }
    .swal2-popup .swal2-content #swal2-content span{
        font-size: 18px;
        line-height: 25px;
    }
    .swal2-popup .swal2-content #swal2-content span b{
        font-size: 20px;
    }
</style>
